import { useRef, useState } from 'react';
import { loggerInfo } from 'utils/infoLog';
import { getPdfOrders } from 'services/services';
import { useToast } from '@welbe/web-design-system';

type DownloadOrdersButtonPartials = {
	id: string;
	name: string;
	exams: {
		orderId: string;
		name: string;
		appointmentId: string;
		healthCenterName: string;
		orderStatus: string;
	}[];
};

export type DownloadOrdersButtonProps = {
	appointmentId: string;
	exams: {
		orderId: string;
		name: string;
		appointmentId: string;
		healthCenterName: string;
		orderStatus: string;
	}[];
} & DownloadOrdersButtonPartials;

export const useDownloadOrdersButton = ({
	id,
	name,
	exams,
}: DownloadOrdersButtonPartials) => {
	const { toast } = useToast();
	const containerRef = useRef<HTMLDivElement>(null);
	const [showExternalOrderModal, setShowExternalOrderModal] = useState('');
	const [loading, setLoading] = useState(false);
	const [visible, setVisible] = useState(false);
	const [position, setPosition] = useState({ x: 0, y: 0 });

	const handleError = (error: any) => {
		const statusError: any = {
			500: 'Ocurrió un error al descargar los folios',
			404: 'No se encontraron folios',
		};
		toast.error(statusError[error.response?.status] || 'Ocurrió un error');
		loggerInfo({
			data: error,
			context: 'candidate',
			location: 'DownloadOrdersButton',
			payloadRequest: { id },
		});
	};

	const fetchFile = (url: string) => {
		const link = document.createElement('a');
		link.setAttribute('href', url);
		link.setAttribute('target', '_blank');
		link.setAttribute('download', `${name} folios.pdf`);
		document.body.appendChild(link);
		link.click();
		link?.parentNode?.removeChild(link);
	};

	const checkMultipleExternalOrder = () =>
		exams.some((exam) => exam.appointmentId !== exams[0].appointmentId);

	const handleDownload = async (appointmentId: string) => {
		try {
			setLoading(true);
			const { data } = await getPdfOrders(appointmentId);
			fetchFile(data.content.path);
		} catch (error) {
			handleError(error);
		} finally {
			setLoading(false);
		}
	};

	const handleHover = (state: boolean) => {
		if (!containerRef.current) return;

		const { x, y } = containerRef.current.getBoundingClientRect();
		setPosition({ x, y });
		setVisible(state);
	};

	return {
		loading,
		visible,
		position,
		containerRef,
		showExternalOrderModal,
		setShowExternalOrderModal,
		checkMultipleExternalOrder,
		handleDownload,
		handleHover,
	};
};
